import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch
} from "@mui/material";
import { useState } from "react";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { TFiltroHistoricoRecebimento } from "..";

export default function DialogHistoricoEntradaFilter({
  open,
  filtrosAtuais,
  onClose,
  onConfirm
}: DialogHistoricoEntradaFilterProps) {

  const [internalFilters, setInternalFilters] = useState<TFiltroHistoricoRecebimento>(filtrosAtuais);

  const handleConfirm = () => {
    const novosFiltros: TFiltroHistoricoRecebimento = {
      ...filtrosAtuais,
      status: internalFilters.status ? internalFilters.status : undefined,
      somenteValorOperacao: internalFilters.somenteValorOperacao
    };

    onConfirm(novosFiltros);
    onClose();
  };

  const clearFiltros = () => {
    setInternalFilters({});
    onConfirm({});
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Filtros
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={{ xs: 12 }}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="switch-operacao" sx={{ mb: 1 }}>
                Somente valor da operação
              </InputLabel>
              <Switch
                id="switch-operacao"
                checked={!!internalFilters.somenteValorOperacao}
                onChange={(_, checked) => {
                  setInternalFilters({
                    ...internalFilters,
                    somenteValorOperacao: checked
                  });
                }}
                color="primary"
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControl fullWidth>
              <InputLabel id="status-select-label">Status</InputLabel>
              <Select
                labelId="status-select-label"
                id="status-select"
                value={internalFilters.status ? internalFilters.status[0] : ''}
                label="Status"
                onChange={(event) => {
                  setInternalFilters({
                    ...internalFilters,
                    status: event.target.value ? [event.target.value] : undefined
                  });
                }}
              >
                <MenuItem value=""><em>Selecione um status</em></MenuItem>
                <MenuItem value="Recebido com sucesso">Recebido com sucesso</MenuItem>
                <MenuItem value="Aguardando chegada">Aguardando chegada</MenuItem>
                <MenuItem value="Aguardando aprovação fiscal">Aguardando aprovação fiscal</MenuItem>
                <MenuItem value="Análise de divergência">Análise de divergência</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={clearFiltros}>Limpar</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
interface DialogHistoricoEntradaFilterProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (filters: TFiltroHistoricoRecebimento) => void;
  filtrosAtuais: TFiltroHistoricoRecebimento;
}